// Copyright (c) 2025 by Audere

import { LabelTask } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
  translationLabelingTask,
  translationQuestions,
} from "./common";

export const celosiaLabelingTypes = [
  ...commonLabelingTypes,
  {
    id: "northernNdebeleTranslationLabeling",
    name: "Translation labeling Northern Ndebele",
    description: "Label the translation quality of Northern Ndebele language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
  {
    id: "shonaTranslationLabeling",
    name: "Translation labeling Shona",
    description: "Label the translation quality of Shona language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
] as const;

const celosiaLabelingTasks: LabelTask[] = [
  ...commonLabelingTasks,
  ...translationLabelingTask,
];

const celosiaQuestions = [...commonQuestions, ...translationQuestions];

export const celosiaLabelingSchemaV1 = {
  labelingTypes: celosiaLabelingTypes,
  labelingTasks: celosiaLabelingTasks,
  labelingQuestions: celosiaQuestions,
  labelingSchemaVersion: "celosiaLabelingSchemaV1",
};
